module.exports = __webpack_public_path__ + "static/tild3139-6535-4361-b363-326635353530__4_forbes-3312722ef9bdf6c70e188e02fd799113.jpg";